function getSelect2Plugin() {
    return import(/* webpackChunkName: "select3" */ 'select2');
}

export default function initSelectMenuTypeAhead(element, customConfiguration) {
    const defaultConfiguration = {
        theme: 'bootstrap'
    };

    let configuration = Object.assign({}, defaultConfiguration, customConfiguration);

    getSelect2Plugin().then(() => {
        element.select2(configuration);
    });
}
